$(function() {
    $(".nav-link").click(function(){
        var linkId = this.id;
        $("#nav-bar li.selected").removeClass("selected");
        $("#"+linkId).addClass("selected");
        $("#"+linkId+"-profile-wrap").fadeIn("slow");
        $('div[id$="-profile-wrap"]').not("#"+linkId+"-profile-wrap").fadeOut("slow");
    });
    $(window).scroll(function() {
      var winWidth = $(window).width();
      if (winWidth <= 798) {
        var scroll = $(window).scrollTop();
        if (scroll <= 90) {
            $("#nav-bar").removeAttr( 'style' );
        } else {
            var offset = $('#header').offset();
            var height = $('#header').height();
            var top = offset.top + height - 10 + "px";
            $("#nav-bar").css("position", "absolute");
            $("#nav-bar").css("background", "rgba(27,31,35,.9)");
            $("#nav-bar").css("color", "white");
            $("#nav-bar").css("width", "100%");
            $("#header").after($("nav-bar").html());
            $("#nav-bar").css("top", top);
        }
      }
    });
});
function viewPort(elemV) {
    let elementTop = $(elemV).offset().top;
    let elementBottom = elementTop + $(elemV).outerHeight();
  
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + window.innerHeight; // <-- here is the height fix
  
    return elementBottom > viewportTop && elementTop < viewportBottom;
};
